import React from "react";
import { Card, Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const UserListSkeleton = () => {
  return (
    <Card className="shadow-sm border-0 p-4 rounded-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-1">Users</h5>
        </div>
      </div>

      <Table hover className="mt-3">
        <thead>
          <tr className="text-secondary">
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Date Created</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody className="text-secondary">
          {Array.from({ length: 10 }).map((_, index) => (
            <tr key={index}>
              <td>
                <Skeleton width={100} height={20} />
              </td>
              <td>
                <Skeleton width={150} height={20} />
              </td>
              <td>
                <Skeleton width={100} height={20} />
              </td>
              <td>
                <Skeleton width={80} height={20} />
              </td>
              <td>
                <Skeleton width={60} height={20} />
              </td>
              <td>
                <Skeleton width={80} height={30} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Card>
  );
};

export default UserListSkeleton;